import { useState, useEffect } from 'react'

export default function useDevelopersLoader () {
  const [ developers, setDevelopers ] = useState([])
  const [ developersLoading, setDevelopersLoading ] = useState(false)

  useEffect(() => {
    setDevelopersLoading(true)

    const fetchInitial = async () => {
      const data = await fetch('/api/internal/developersMap/data')
        .then(response => {
          setDevelopersLoading(false)
          return response.json()
        })

      setDevelopers(data)
    }

    fetchInitial()

    return () => {}
  }, [])

  return {
    loading: developersLoading,
    developers
  }
}